<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div>
      <div class="p-6">
        <div class="pb-4 text-xl">Coordinator Visit Information</div>
        <div class="info" v-for="(value, name, id) in data" :key="id">
          <div class="bold">{{ name.replace('_', ' ') }}:</div>
          <div class="value">{{ value }}</div>
        </div>

        <div class="info" v-if="visitFormUrl != null">
          <div class="bold">Visit Form:</div>
          <a class="value" :href="visitFormUrl"> View Visit Form</a>
        </div>

        <button class="pad btn btn-primary float-right" @click="closeModal()">Close</button>
        <button v-if="canDestroy" class="pad btn btn-secondary float-right" @click="deleteVisit()">Delete</button>
        <button v-if="canEdit" class="pad btn btn-secondary float-right" @click="editVisit()">Edit</button>

        <div class="h-10">&nbsp;</div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'
  import axios from "axios"

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let visitor = ref('')
  let visitedAt = ref('')
  let visitNumber = ref(null)
  let report = ref('')
  let canEdit = ref(props.params.data.can_edit)
  let canDestroy = ref(props.params.data.can_destroy)
  let visitFormUrl = ref('')
  let data = ref({})

  onMounted(() => {
    const frvData = props.params.data.field_rep_visit
    visitFormUrl.value = props.params.data.url

    data.value = {
      Visitor: frvData.visitor,
      Visited_At: frvData.visited_at.split('T')[0],
      Visit_Number: frvData.visit_number,
      Report: frvData.report_text,
    }
  })


  function closeModal () {
    emit('close')
  }

  function editVisit () {
    window.location.href = `/field_rep_visits/${props.params.data.field_rep_visit.id}/edit`
  }

  async function deleteVisit () {
    if (confirm("Are you sure you want to delete this visit?")) {
      await axios.delete(`/field_rep_visits/${props.params.data.field_rep_visit.id}.json`)
      location.reload(true)
    }
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
  .info {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
  }
</style>
